<app-table
  *ngIf="cols && dropdownFilters"
  [cols]="cols"
  pageFunctionName="getProductsList"
  [service]="productService"
  modelName="produtos"
  sortField="name"
  [sortOrder]="-1"
  [defaultRows]="10"
  [changeColumns]="true"
  [addButton]="permission"
  [addButtonAction]="true"
  addLabel="Sincronizar SKUs"
  addButtonIcon="pi pi-refresh"
  [dropdownFilters]="dropdownFilters"
  (booleanAction)="updatePublished($event)"
  (addButtonClick)="showMillenniumSkuDialog = true"
  [extraButton]="permission"
  extraLabel="Sincronizar Millennium"
  (extraButtonClick)="syncMillennium()"
/>

<p-dialog
  header="Sincronizar SKUs no Millennium"
  [(visible)]="showMillenniumSkuDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '36rem' }"
  styleClass="millennium-sku-dialog"
>
  <form
    class="form-b4a modal-form"
    [formGroup]="millenniumSkuForm"
    (submit)="syncMillenniumBySkus()"
  >
    <span class="p-float-label">
      <p-chips
        inputId="millennium-skus"
        formControlName="skus"
        [separator]="chipRegex"
        [addOnBlur]="true"
        [addOnTab]="true"
        [allowDuplicate]="false"
        [style]="{ width: '100%' }"
        styleClass="millennium-sku-dialog__chips"
        placeholder="Ex.: 167353, 170241"
      />
      <label for="millennium-skus">SKUs</label>
    </span>
    <small>Separe os SKUs por vírgula, ponto, ponto e vírgula ou espaço.</small>

    <div class="buttons">
      <button
        pButton
        type="button"
        label="Cancelar"
        class="p-button-text"
        (click)="showMillenniumSkuDialog = false"
      ></button>
      <button
        pButton
        type="submit"
        label="Sincronizar SKUs"
        icon="pi pi-refresh"
        [disabled]="!millenniumSkuForm.controls.skus.value.length"
      ></button>
    </div>
  </form>
</p-dialog>

<p-toast />
